import { render, staticRenderFns } from "./Cv.vue?vue&type=template&id=44f969fa&scoped=true&"
import script from "./Cv.vue?vue&type=script&lang=js&"
export * from "./Cv.vue?vue&type=script&lang=js&"
import style0 from "./Cv.vue?vue&type=style&index=0&id=44f969fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f969fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBanner } from 'vuetify/lib/components/VBanner';
installComponents(component, {VBanner})
